import angular from 'angular'
import { react2angular } from 'react2angular'
import '../../../main/factory/settlement'
import '../../../core/main/factory/analytics'
import SettlementsList from "./SettlementsList.react";

angular.module('merchant.application.module.settlement.settlementList', [
  'merchant.application.main',
  'core.application.main'
]).controller('merchant.application.module.settlement.settlementList.controller',
  ['$rootScope', '$scope', '$controller'],
  function ($rootScope, $scope, $controller) {
    $controller('merchant.application.module.controller', { $scope: $scope })
  })
  .component('settlementsList',
    react2angular(SettlementsList,
      ['channel', 'hasChannels', 'configuration'],
      ['$scope', '$location', 'merchant.application.main.factory.settlement', 'core.application.main.factory.analytics']))
